import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrivyProvider } from '@privy-io/react-auth';
import { toSolanaWalletConnectors } from '@privy-io/react-auth/solana';
import App from './App';
import { VendorProvider } from './context/VendorContext';
import vendorConfig from './vendors/vendorConfig';
import './styles/global.css';

// Polyfill Buffer for Privy's internal dependencies
window.Buffer = Buffer;

// Solana wallet connectors - only if wallet login is enabled
const solanaConnectors = vendorConfig.features.walletLogin
  ? toSolanaWalletConnectors({ shouldAutoConnect: false })
  : undefined;

// Get the logo URL from vendor config
const getLogoUrl = () => {
  const iconPath = vendorConfig.branding.logoIconUrl || '/icons/logo-icon.svg';
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${iconPath}`;
  }
  return iconPath;
};

// Privy app ID: vendor-specific or default from env
const privyAppId = vendorConfig.auth.privyAppId || process.env.REACT_APP_PRIVY_APP_ID;

// Privy configuration - driven by vendor config
const privyConfig = {
  loginMethods: vendorConfig.auth.loginMethods,
  appearance: {
    theme: 'light',
    accentColor: '#8B5CF6',
    logo: getLogoUrl(),
    showWalletLoginFirst: vendorConfig.auth.showWalletLoginFirst,
    walletList: vendorConfig.auth.walletList,
    walletChainType: vendorConfig.features.walletLogin ? 'ethereum-and-solana' : 'ethereum-only',
  },
  embeddedWallets: {
    ethereum: {
      createOnLogin: 'all-users'
    }
  },
  walletConnectCloudProjectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID,
  ...(solanaConnectors ? {
    externalWallets: {
      solana: {
        connectors: solanaConnectors
      }
    }
  } : {})
};

// Set favicon from vendor config
if (vendorConfig.branding.faviconUrl) {
  const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
  link.rel = 'icon';
  link.href = vendorConfig.branding.faviconUrl;
  if (!link.parentNode) document.head.appendChild(link);
}

// Set document title from vendor config
document.title = `${vendorConfig.branding.appName} - ${vendorConfig.branding.tagline}`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PrivyProvider
    appId={privyAppId}
    config={privyConfig}
  >
    <VendorProvider>
      <App />
    </VendorProvider>
  </PrivyProvider>
);
